<template>
  <DialogBase
    title="Hủy liên kết ngân hàng"
    :visible.sync="showUnConnectionBanksDialog"
    width="550px"
    panel-icon="el-icon-warning"
    panel-icon-tone="danger"
    panel-title="XÁC NHẬN HỦY LIÊN KẾT"
    panel-subtitle="Hệ thống sẽ ngừng đồng bộ mọi giao dịch tự động sau khi hủy kết nối."
    :confirm-loading="loading.submit"
    confirm-text="Hủy kết nối ngay"
    confirm-type="danger"
    confirm-icon="el-icon-circle-close"
    cancel-text="Hủy bỏ"
    @before-close="handleClose"
    @cancel="handleClose"
    @confirm="handleDelete"
    @open="handleOpen"
  >
    <div class="dialog-inner-body">
      <!-- Warning alert box -->
      <div class="warning-alert-panel mb-3">
        <div class="alert-title">
          <i class="el-icon-warning"></i> Cảnh báo hành động nguy hiểm
        </div>
        <p class="alert-desc">
          Bằng việc chấp thuận hủy kết nối tài khoản này, hệ thống sẽ ngừng đồng bộ mọi giao dịch tự động. Quá trình này yêu cầu xác thực OTP bảo mật từ ngân hàng liên kết.
        </p>
      </div>

      <el-form
        :model="formData"
        :rules="rules"
        ref="formData"
        label-position="top"
        class="modern-form"
      >
        <el-form-item label="Nhập mã xác thực OTP gửi về điện thoại:" prop="otp">
          <el-input
            v-model="formData.otp"
            placeholder="Nhập mã OTP gồm 6 chữ số..."
            prefix-icon="el-icon-key"
            class="otp-input-style"
          />
        </el-form-item>
      </el-form>

      <!-- Resend OTP control block -->
      <div class="resend-otp-container mt-4">
        <span class="resend-text">Không nhận được mã hoặc mã OTP hết hạn?</span>
        <el-button
          type="text"
          class="resend-btn-link"
          :disabled="countdown > 0"
          @click="resendOTP"
        >
          {{ countdown > 0 ? `Gửi lại mã OTP (${countdown}s)` : 'Gửi lại mã OTP ngay' }}
        </el-button>
      </div>
    </div>
  </DialogBase>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import sePayConnectionService from "@/services/SePayConnectionService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "UnConnectionBanksDialog",
  components: { DialogBase },
  props: {
    showUnConnectionBanksDialog: {
      type: Boolean,
      default: () => false
    },
    bank: {
      type: Object,
      default: () => null
    },
    request_id: {
      type: String,
      default: () => ""
    }
  },
  
  data() {
    return {
      formData: {
        otp: "",
        idBankAccount: 0,
        brandName: "",
        request_id: ""
      },
      rules: {
        otp: [
          {
            required: true,
            message: "Mã OTP không được để trống!",
            trigger: "change"
          }
        ]
      },
      loading: {
        submit: false
      },
      countdown: 30,
      countdownTimer: null
    };
  },

  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
  },

  methods: {
    handleOpen() {
      if (this.bank) {
        this.formData.brandName = this.bank.bankName || "";
        this.formData.idBankAccount = this.bank.idBankAccount || 0;
      }
      this.formData.request_id = this.request_id;
      this.countdown = 30;
      this.startCountdown();
    },

    handleDelete() {
      this.$refs["formData"].validate(async (valid) => {
        if (valid) {
          this.loading.submit = true;
          try {
            const resp = await sePayConnectionService.confirmRequestDeleteBankAccount(this.formData);
            if (resp.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Hủy liên kết với ngân hàng thành công!");
              this.handleClose();
            } else {
              NotifyMessage.leftCornerNotificationError("Hủy liên kết với ngân hàng thất bại!");
              this.handleClose();
            }
          } catch (err) {
            console.error(err);
          } finally {
            this.loading.submit = false;
          }
        }
      });
    },

    async resendOTP() {
      if (!this.bank) return;
      this.countdown = 30;
      let data = {
        idBankAccount: this.bank.idBankAccount,
        brandName: this.bank.bankName
      };
      try {
        const resp = await sePayConnectionService.sendRequestDeleteBankAccount(data);
        if (resp.data.data.code === "200") {
          this.$emit("update:request_id", resp.data.data.data.request_id);
          this.formData.request_id = resp.data.data.data.request_id;
          NotifyMessage.leftCornerNotificationSuccess("Đã gửi lại OTP xác thực. Vui lòng kiểm tra điện thoại!");
        } else {
          NotifyMessage.leftCornerNotificationError("Gửi OTP thất bại!");
        }
      } catch (err) {
        console.error(err);
      }
      this.startCountdown();
    },

    startCountdown() {
      if (this.countdownTimer) clearInterval(this.countdownTimer);
      this.countdownTimer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--;
        } else {
          clearInterval(this.countdownTimer);
        }
      }, 1000);
    },

    handleClose() {
      this.$refs["formData"].resetFields();
      this.$emit("closeDialog");
    }
  }
};
</script>

<style lang="scss" scoped>
.warning-alert-panel {
  background-color: #fef2f2;
  border-left: 4px solid #ef4444;
  padding: 12px 16px;
  border-radius: 6px;

  .alert-title {
    font-weight: 700;
    font-size: 13px;
    color: #991b1b;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .alert-desc {
    margin: 4px 0 0 0;
    font-size: 12px;
    color: #b91c1c;
    line-height: 1.5;
  }
}

.modern-form {
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }

  /deep/ .el-form-item__label {
    font-weight: 600;
    color: #475569;
    padding-bottom: 6px;
  }

  /deep/ .el-input__inner {
    border-radius: 8px;
    height: 44px;
    font-size: 14px;
    text-align: center;
    letter-spacing: 2px;
    font-family: Consolas, Monaco, monospace;
    font-weight: 700;
  }
}

.resend-otp-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  background-color: #f8fafc;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #cbd5e1;

  .resend-text {
    font-size: 12px;
    color: #64748b;
  }

  .resend-btn-link {
    font-weight: 700;
    color: #2563eb;
    padding: 0;
    font-size: 13px;

    &[disabled] {
      color: #94a3b8;
    }
  }
}

.mb-3 { margin-bottom: 12px; }
.mt-4 { margin-top: 16px; }
</style>
